import { openPdf } from '../../helpers'

export default {
  name: 'card file',
  props: {
    infos: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  methods: {
    openPdf
  }
}
